import { jsxs, jsx } from 'react/jsx-runtime';
import { getTestIdByDisplayName } from '../../../Icons/Icon.js';

/**
*/
function AlertIcon() {
    return (jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", height: "20px", viewBox: "0 0 4 20", width: "4px", "data-testid": getTestIdByDisplayName('AlertIcon'), children: [jsx("path", { d: "M0 0h4v20H0V0z", fill: "none" }), jsx("path", { d: "M0.8,3.4c0.8,0,1.5,0,2.3,0c0,3-0.1,6-0.2,8.9c0,0.2,0,0.2-0.2,0.2c-0.5,0-0.9,0-1.4,0c-0.1,0-0.2,0-0.2-0.2C0.9,9.4,0.9,6.4,0.8,3.4z" }), jsx("path", { d: "M1.9,16.6c-1.9-0.1-1.4-2.7,0.3-2.3C3.6,14.6,3.3,16.6,1.9,16.6z" })] }));
}

export { AlertIcon as default };
